export default __webpack_public_path__ + "static/media/Tejaswi_Bandla.562b34a7.jpeg";